import moment from 'moment';
import React, { useState } from 'react'
import { Button, Form, Modal } from '@themesberg/react-bootstrap';
import { getLotoRewardLabel, getLotoTypeLabelWithFilter } from '../../../../helper/lotoType'

export const TableRow = (props) => {
  const {
    userName,
    userPhone,
    numbers,
    cartId,
    value,
    status,
    confirmAt,
    lotoType,
    id,
    isSelected,
    onSelect,
    rewardCount,
    rewardValue,
    rewardUnitValue,
    rewardName,
    baoFilter,
    baoDigits,
  } = props;

  const [showDetail, setShowDetail] = useState(false)

  const statusText = status === 4 ? 'Trúng thưởng' : status === 5 ? 'Không trúng' : 'Chờ tính lại'
  const canRecalculate = status === 4 || status === 5
  const canViewRewardDetail = status === 4
  const rewardTotal = Number(rewardValue || 0)
  const rewardHitCount = Number(rewardCount || 0)
  const displayRewardUnitValue = rewardHitCount > 0
    ? rewardTotal / rewardHitCount
    : Number(rewardUnitValue || 0)
  const formattedRewardValue = new Intl.NumberFormat('vn-VI', {}).format(Number(rewardValue || 0))
  const formattedRewardUnitValue = new Intl.NumberFormat('vn-VI', {}).format(displayRewardUnitValue)
  const formattedTicketValue = new Intl.NumberFormat('vn-VI', {}).format(Number(value || 0))

  return (
    <>
      <tr>
        <td className='text-center'>
          <Form.Check
            type="checkbox"
            checked={isSelected || false}
            disabled={!canRecalculate}
            onChange={(event) => onSelect && onSelect(id, event.target.checked)}
          />
        </td>
        <td>
          {userName || ""}<br />
          <span><strong className={`text-primary`}>{userPhone || ""}</strong></span>
        </td>
        <td className='text-center'>{cartId}</td>
        <td className='text-center'><strong>{getLotoTypeLabelWithFilter(lotoType, baoFilter, baoDigits)}</strong></td>
        <td className='text-center'><strong>{(numbers || "").split('').join(' ')}</strong></td>
        <td className='text-center'>{formattedTicketValue}</td>
        <td className={`text-center${status === 4 ? ' text-danger' : status === 3 ? ' text-warning' : ''}`}>{statusText}</td>
        <td className='text-center'>
          {canViewRewardDetail ? <strong className="text-danger">{formattedRewardValue}</strong> : '-'}
        </td>
        <td className='text-center'>
          {canViewRewardDetail ? (
            <Button variant="info" size="sm" onClick={() => setShowDetail(true)}>
              Xem chi tiết
            </Button>
          ) : '-'}
        </td>
        <td className='text-center'>{moment(confirmAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</td>
      </tr>

      <Modal show={showDetail} onHide={() => setShowDetail(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Chi tiết trúng thưởng</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div className="text-muted small">Mã vé</div>
            <strong>{id}</strong>
          </div>
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>Cách chơi</span>
            <strong>{getLotoTypeLabelWithFilter(lotoType, baoFilter, baoDigits)}</strong>
          </div>
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>Dãy số</span>
            <strong>{(numbers || "").split('').join(' ')}</strong>
          </div>
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>Mã giải</span>
            <strong>{getLotoRewardLabel(rewardName) || '-'}</strong>
          </div>
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>Số lần trúng</span>
            <strong>{new Intl.NumberFormat('vn-VI', {}).format(Number(rewardCount || 0))}</strong>
          </div>
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>Đơn giá thưởng</span>
            <strong>{formattedRewardUnitValue}</strong>
          </div>
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>Giá trị vé</span>
            <strong>{formattedTicketValue}</strong>
          </div>
          <div className="d-flex justify-content-between pt-3 fs-5">
            <span>Tổng tiền thưởng</span>
            <strong className="text-danger">{formattedRewardValue}</strong>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetail(false)}>
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
